import Cookie from 'js-cookie';

import { stringUriToBase64 } from '@utils/braintreeUtils';

const isQueryParamsPresentInUrl = (urlString: string, queryParams: string[]) => {
  const url = new URL(urlString);
  const extractedQueryParam = queryParams.map(queryParam => url.searchParams.get(queryParam));
  return extractedQueryParam.every(param => !!param);
};

export const isReturnUrlFromAdyen = (urlString: string) =>
  isQueryParamsPresentInUrl(urlString, ['redirectResult', 'shopperStatement']);

export const computeMobileReturnUrl = (
  mobileAppURLSchema?: string,
  forceToNativeBrowser = false,
) => {
  if (forceToNativeBrowser) {
    return `${mobileAppURLSchema}${window.location.pathname}`;
  }
  return `${window.location.origin}${window.location.pathname}`;
};

export const getOrderDetailsUrl = () => {
  const isPaymentResultUrl =
    isQueryParamsPresentInUrl(window.location.href, ['authResult']) ||
    isQueryParamsPresentInUrl(window.location.href, ['auth']);
  return isPaymentResultUrl
    ? window.location.href
    : `${window.location.origin}${window.location.pathname}`;
};

export const getMobileAppsReturnUrl = (mobileAppURLSchema: string, forceToNativeBrowser = false) =>
  computeMobileReturnUrl(mobileAppURLSchema, forceToNativeBrowser);

export const encodePageUrlasBase64 = (): string => stringUriToBase64(getOrderDetailsUrl());

export const isRecognizedApp = (value: unknown): value is 'android' | 'ios' =>
  typeof value === 'string' && ['android', 'ios'].includes(value);

export const getMobileAppType = () => Cookie.get('MOBILE_APP');
